//
// Copyright (c) 2011-2017 by Curalate, Inc.
//

/* global angular: false, ActiveXObject */

(function() {
  const curalate = angular.module('curalate');

  curalate.service('FlashUtils', [
    function() {
      this.isFlashEnabled = function() {
        try {
          const fo = new ActiveXObject('ShockwaveFlash.ShockwaveFlash');
          if (fo) {
            return true;
          }
        } catch (exception) {
          if (navigator.mimeTypes &&
                        navigator.mimeTypes['application/x-shockwave-flash'] !== undefined &&
                        navigator.mimeTypes['application/x-shockwave-flash'].enabledPlugin) {
            return true;
          }
        }

        return false;
      };
    },
  ]);
})();
